module.exports = "https://coursera_assets.s3.amazonaws.com/images/4434555daa88df4f1cb5a79b47f7aab1.jpg";